<script setup>
import * as PIXI from "pixi.js";

import { ref, onMounted, onUnmounted, reactive, defineProps } from "vue";

const heightRatio = 960 / 1920;
const width = 1920;
const height = width * heightRatio;

const pixiContainer = ref(null);
let app = null;

import { simplifyWhiteboard } from "./util";

const props = defineProps({
    data: {
        type: Object,
    },
});

const state = reactive({
    players: [],
    circles: [],
});

async function getWhiteboard() {
    const resp = await axios.get(
        `http://127.0.0.1:8080/api/loadwhiteboard?wid=${props.data.room_code}`
    );
    state.players = simplifyWhiteboard(resp.data);

    let _circles = [];
    for (const key in state.players) {
        const player = state.players[key];
        const x = player.d[3];
        const y = player.d[4];
        const circle = new PIXI.Graphics()
            .circle(x, y, 20)
            .fill("white")
            .stroke({
                color: 0x000000,
                width: 3,
            });
        _circles.push(circle);
        app.stage.addChild(circle);
    }

    state.circles = _circles;

    app.ticker.add((time) => {
        _circles[0].x += 0.5 * time.deltaTime;
    });
}

onMounted(async () => {
    if (!pixiContainer.value) return;

    app = new PIXI.Application();
    await app.init({
        width,
        height,
        backgroundColor: 0xffffff,
        antialias: true,
        resolution: window.devicePixelRatio,
    });

    pixiContainer.value.appendChild(app.canvas);

    const texture = await PIXI.Assets.load(props.data.background);
    const bg = new PIXI.Sprite(texture);
    bg.x = 0;
    bg.y = 0;
    bg.width = app.screen.width;
    bg.height = app.screen.height;
    bg.alpha = 0.2;
    app.stage.addChild(bg);

    getWhiteboard();
});

onUnmounted(() => {
    if (app) {
        app.destroy(true, { children: true, texture: true, baseTexture: true });
        app = null;
    }
});
</script>

<template>
    <div id="pixi" ref="pixiContainer" style="width: 100%; height: 100%"></div>
</template>

<style>
#pixi canvas {
    width: 100%;
    aspect-ratio: 2.07339829981;
}
</style>
